import React from 'react';
import { MdEmail, MdPhone, MdLocationOn } from 'react-icons/md';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Footer = () => {
  const colors = {
    darkCharcoal: '#1F2937', 
    lightCharcoal: '#374151', 
    softGrey: '#9CA3AF',    
    primaryGreen: '#10B981', 
    accentGreen: '#059669',  
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="krishidnya-footer">
      <div className="footer-container">
        
        <div className="footer-content">
          
          <div className="footer-brand">
            <h3 className="company-name-title">Krishidnya</h3>
            <p className="footer-description">
              Empowering farmers with technology and sustainable growth.
            </p>
            <div className="social-links">
              <a 
                href="https://facebook.com" 
                className="social-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebook />
              </a>
              <a 
                href="https://twitter.com" 
                className="social-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaTwitter />
              </a>
              <a 
                href="https://www.instagram.com/krishidnya?igsh=a2VsNjNzZjc3OGFn" 
                className="social-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram />
              </a>
              <a 
                href="https://www.linkedin.com/company/krishidnya" 
                className="social-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin />
              </a>
            </div>
          </div>

          <div className="footer-contact">
            <h3 className="footer-title">Connect</h3>
            <div className="contact-item">
              <MdEmail className="contact-icon" />
              <span>hello@krishidnya.com</span>
            </div>
            <div className="contact-item">
              <MdPhone className="contact-icon" />
              <span>+91 8010825179</span>
            </div>
            <div className="contact-item">
              <MdLocationOn className="contact-icon" />
              <span>Pune, India</span>
            </div>
          </div>
          
        </div>

        <div className="footer-bottom">
          <div className="footer-links">
            <Link to="/privacy-policy" className="footer-link">
              Privacy Policy
            </Link>
            <Link to="/terms-of-service" className="footer-link">
              Terms of Service
            </Link>
            <Link to="/delete-account" className="footer-link">
              Delete Account
            </Link>
          </div>
          <p>&copy; {currentYear} Krishidnya. All rights reserved.</p>
        </div>

      </div>

      <style jsx>{`
        .krishidnya-footer {
          --footer-bg: ${colors.darkCharcoal};
          --footer-text: ${colors.softGrey};
          --footer-highlight: ${colors.primaryGreen};
          --footer-border: ${colors.lightCharcoal};
          --footer-icon: ${colors.accentGreen};
          
          background: var(--footer-bg);
          color: white;
          padding: 60px 0 20px;
          font-family: 'Inter', sans-serif;
          border-top: 8px solid var(--footer-highlight);
        }

        .footer-container {
          max-width: 1000px;
          margin: 0 auto;
          padding: 0 20px;
        }
        
        .footer-content {
          display: grid;
          grid-template-columns: 2fr 1fr;
          gap: 60px;
          margin-bottom: 40px;
        }
        
        .footer-title, .company-name-title {
          font-size: 1.05rem;
          font-weight: 700;
          color: white;
          position: relative;
        }

        .company-name-title {
            font-size: 1.25rem;
            font-weight: 900;
            margin-bottom: 15px;
        }
        
        .footer-title {
          margin-bottom: 20px;
        }

        .footer-title::after {
            content: '';
            position: absolute;
            left: 0;
            bottom: -5px;
            width: 30px;
            height: 3px;
            background: var(--footer-highlight);
            border-radius: 2px;
        }
        
        .footer-contact {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .contact-item {
          display: flex;
          align-items: flex-start;
          gap: 8px;
          color: var(--footer-text);
          font-size: 1rem;
        }
        
        .contact-icon {
          color: var(--footer-icon);
          min-width: 18px;
          font-size: 18px;
          margin-top: 2px;
        }
        
        .footer-brand {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }
        
        .footer-description {
          color: var(--footer-text);
          line-height: 1.5;
          font-size: 0.95rem;
        }
        
        .social-links {
          display: flex;
          gap: 15px;
          margin-top: 5px;
        }
        
        .social-link {
          font-size: 20px;
          color: var(--footer-text);
          transition: color 0.3s;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.05);
        }
        .social-link:hover {
          color: var(--footer-highlight);
          background: rgba(16, 185, 129, 0.1);
          transform: translateY(-2px);
        }

        .footer-bottom {
          border-top: 1px solid var(--footer-border);
          padding-top: 20px;
          text-align: center;
          color: var(--footer-text);
          font-size: 0.85rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
        }
        
        .footer-links {
          display: flex;
          gap: 20px;
          margin-bottom: 10px;
          flex-wrap: wrap;
          justify-content: center;
        }
        
        .footer-link {
          color: var(--footer-text);
          text-decoration: none;
          font-size: 0.9rem;
          transition: color 0.3s;
        }
        
        .footer-link:hover {
          color: var(--footer-highlight);
          text-decoration: underline;
        }
        
        @media (max-width: 768px) {
          .krishidnya-footer {
            padding: 30px 0 10px;
          }
          
          .footer-container {
            padding: 0 15px;
          }
          
          .footer-content {
            grid-template-columns: 1fr;
            gap: 25px;
            margin-bottom: 25px;
          }

          .company-name-title {
            font-size: 1.15rem;
            margin-bottom: 10px;
          }
          
          .footer-description {
            font-size: 0.95rem;
          }
          
          .footer-contact {
            gap: 8px;
          }
          
          .footer-title {
            margin-bottom: 10px;
            font-size: 1rem;
          }

          .social-links {
            margin-bottom: 10px;
          }
          
          .footer-bottom {
            padding-top: 15px;
          }
          
          .footer-links {
            gap: 15px;
          }
          
          .footer-link {
            font-size: 0.85rem;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;